module.exports = function getResource(label, vars = []) {
    let resources = {
        error: 'Erreur'
    };

    return resources[label];
};
